import {Text} from '@chakra-ui/react';
import {useMe, useSocieteCommerciale} from '@/haligator-factory';
import {HaliRenderOne, useHalState} from '@synako/haligator';
import {useTranslation} from 'react-i18next';

/**
 * Accueil : Salutation personnalisée affichée en haut de la page d'accueil.
 * Côté client, salue le contact connecté ; en mode commercial, salue le
 * représentant connecté.
 * Version ordinateur (`carte`) : « Bonjour {prénom}, » puis « prêt à commander chez {société} ? ».
 * Version mobile (`image`), posée sur la photo d'ambiance : sans la société, déjà dans le logo
 * juste au-dessus.
 */
export const AccueilGreeting: React.FC<{variante: 'carte' | 'image'}> = ({
  variante,
}) => {
  const {t} = useTranslation('common');
  const me = useMe();
  const {data: societe} = useHalState(useSocieteCommerciale());
  const nomSociete = societe?.tolede.nom_commercial;

  // Salutation personnalisée, avec le prénom du contact ou du représentant.
  const greeting = (prenom: string | undefined) => {
    const bonjour = prenom
      ? t('accueil.salutation.bonjour', {prenom})
      : t('accueil.salutation.bonjour_sans_prenom');
    const suite =
      variante === 'carte' && nomSociete
        ? t('accueil.salutation.pret_a_commander_chez', {societe: nomSociete})
        : t('accueil.salutation.pret_a_commander');

    if (variante === 'image') {
      return (
        <Text
          as='h1'
          fontWeight='700'
          fontSize='28px'
          lineHeight='32px'
          letterSpacing='-0.6px'
          color='white'
        >
          {bonjour}
          <br />
          {suite}
        </Text>
      );
    }
    return (
      <Text as='h1'>
        <Text
          as='span'
          display='block'
          fontWeight='700'
          fontSize='2xl'
          lineHeight='28px'
          letterSpacing='-0.4px'
          color='blue.navy'
        >
          {bonjour}
        </Text>
        <Text
          as='span'
          display='block'
          fontWeight='400'
          fontSize='xl'
          lineHeight='28px'
          color='gray.medium'
        >
          {suite}
        </Text>
      </Text>
    );
  };

  return (
    <HaliRenderOne
      nav={me}
      render={({state, data}) => {
        return (
          // Mode client : le prénom vient du contact lié.
          // Mode commercial : pas de contact, le prénom du représentant est sur le state Me.
          state.hasOneLink('contact') ? (
            <HaliRenderOne
              nav={state.follow('contact')}
              render={({data: contact}) => greeting(contact.tolede.prenom)}
            />
          ) : (
            greeting(data.prenom_representant)
          )
        );
      }}
    />
  );
};
